import { useQuery } from 'react-query';

import { getAsigneList as queryFn } from 'api/endPoints/getAsigneList';
import { QueryKeys } from 'api/queryKeys';

export const useQueryAssigneeList = (endpoint?: string) => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys]>({
        queryKey: ['assigneeList'],
        queryFn: () => queryFn(endpoint),
    });
};

interface QueryResponse {
    firstName: string;
    id: null;
    lastName: string;
    userName: string;
}
